// ============================================================
// VCS.state — Zentraler App-State
// ============================================================
// Lädt als Erste (nach helpers.js). Kein Code außer der
// State-Definition.
// ============================================================
window.VCS = window.VCS || {};

// ── Hilfsfunktionen nur für die Initialisierung ─────────────

function _detectLangInit() {
    const nav = (navigator.language || '').toLowerCase().slice(0, 2);
    const available = ['de', 'en', 'ru', 'fr', 'es', 'it', 'pt'];
    return available.includes(nav) ? nav : 'de';
}

function _normalizeAudioModeInit(value) {
    if (value === 'standard' || value === 'speech' || value === 'music') {
        return value;
    }
    return 'speech';
}

// ── VCS.state ────────────────────────────────────────────────

VCS.state = {

    // Sprache
    currentLang: localStorage.getItem('call-lang') || _detectLangInit(),

    // Verbindung
    ws:                    null,
    pc:                    null,
    reconnectAttempts:     0,
    reconnectTimer:        null,
    pendingRegisterOnOpen: false,
    // Presence: true wenn die App im Hintergrund liegt und wir die WS bewusst
    // getrennt haben. Verhindert Reconnect im Hintergrund; Vordergrund baut
    // die WS wieder auf und re-authet den Chat (Server broadcastet 'online').
    presenceHidden:        false,

    // Identität
    myId:   localStorage.getItem('call-client-id') || Math.random().toString(36).substring(2, 9),
    myName: '',
    myRole: null,           // 'host' | 'guest'

    // Session
    ROOM_ID:      null,
    sessionState: { name: '', phase: 'prejoin', role: null },

    // Call — Streams
    localStream:          null,
    remoteStream:         null,
    baseStream:           null,
    processedVideoTrack:  null,

    // Call — Zustand
    audioMuted:         false,
    videoOff:           false,
    speakerOff:         false,

    // Gespraechszusammenfassung (2026-09-08)
    callSummaryAvailable: false,  // Recht laut Server (chat-authed)
    callSummaryWish:      false,  // fuer diesen einen Call gewuenscht
    callSummaryActive:    false,  // Server schreibt mit (call-summary-state)
    summaryCapture:       false,  // Server will Aufnahme fuer die Mitschrift (summary-capture), unabhaengig von CC
    callSummaryPeerActive: false, // Gegenueber laesst zusammenfassen (call-summary-peer)
    callSummaryPeerOrderers: [],  // Gruppen-Call: clientIds der anderen Besteller (Symbol an deren Kachel)

    // Live-Unterhaltung / Solo-Dolmetscher (2026-09-20)
    liveConvoAvailable:   false,  // Recht laut Server (chat-authed)
    liveConvoRemote:      false,  // Partner einladen erlaubt (chat-authed, 2026-10-16)
    conciergeAvailable:   false,  // Concierge-Recht laut Server (chat-authed)
    remoteMuted:        false,
    directCallActive:   false,
    directCallPeerName: '',
    directCallPeerPhone:'',

    // Gast-Anruf (Link ohne Konto). guestKey nur auf der Gast-Seite
    // (guest-app.js). guestAcceptPending nur beim Einladenden: das naechste
    // register traegt guestAccept (guest-invite.js).
    guestKey:           null,
    guestCallActive:    false,
    guestAcceptPending: false,
    peerName:           '',
    peerLang:           null,
    candidateQueue:     [],

    // Call — Gast-Queue
    pendingGuestId:     null,
    pendingGuestCamOff: false,

    // Geräte
    selectedCamId:  localStorage.getItem('last-cam-id') || null,
    selectedMicId:  localStorage.getItem('last-mic-id') || null,
    audioMode:      _normalizeAudioModeInit(localStorage.getItem('audio-mode')),
    networkQuality: localStorage.getItem('network-quality') || 'high',
    ringEnabled:    localStorage.getItem('ring-enabled') !== '0',

    // Remote Voice Meter
    remoteVoiceAudioCtx:  null,
    remoteVoiceSourceNode: null,
    remoteVoiceAnalyser:  null,
    remoteVoiceData:      null,
    remoteVoiceRaf:       null,
    remoteVoiceLevelEma:  0,

    // Preview Voice Meter
    previewVoiceAudioCtx:  null,
    previewVoiceSourceNode: null,
    previewVoiceAnalyser:  null,
    previewVoiceData:      null,
    previewVoiceRaf:       null,
    previewVoiceLevelEma:  0,

    // Knock
    knockInterval:  null,
    knockStopTimer: null,
    knockAudioCtx:  null,

    // Blur / Hintergrund
    blurEnabled:       localStorage.getItem('blur-enabled') === '1',
    blurFallbackActive: false,
    blurModel:         null,
    blurModelReady:    false,
    blurSourceVideo:   null,
    blurCanvas:        null,
    blurCtx:           null,
    blurSendTimer:     null,
    blurSendBusy:      false,

    // Kamera-Stop-Logik
    camOffStopTimer: null,
    camHardStopped:  false,
    camOffByButton:  false,

    // Captions / Transkription — Steuerung
    captionsEnabled:      false,
    captionPaused:        false,
    captionEngineActive:  false,
    captionStopping:      false,
    suppressRejoinHint:   false,
    captionOnlyMode:      false,

    // Captions — PCM-Pipeline (Deepgram WS)
    captionPcmStream:   null,
    captionAudioCtxPcm: null,
    captionWorkletNode: null,
    captionSourceNode:  null,
    captionStreaming:   false,
    _captionStarting:   false,

    // Captions — VAD / Recorder (Legacy-Pipeline)
    captionInputStream:    null,
    captionRecorder:       null,
    captionChunks:         [],
    captionRecording:      false,
    captionMimeType:       'audio/webm',
    captionAudioContext:   null,
    captionAnalyser:       null,
    captionVADTimer:       null,
    captionSilenceSince:   0,
    captionSegmentTimeout: null,
    captionSegmentStartedAt: 0,
    captionSpeechSince:    0,
    captionRmsEma:         0,

    // Audio-Toggle (translated audio playback, openai-realtime engine only)
    // 'original' (default): <video> plays direct, no Web-Audio in original path.
    // 'translated': <video> muted, Web-Audio plays translated voice.
    // Reset to 'original' on every call start (no persistence across calls).
    audioFaderMode:            'original',
    audioFaderCtx:             null,
    audioFaderTranslatedGain:  null,
    audioFaderActive:          false,
    // Caption-engine info pushed by the backend on caption-stream init.
    // Audio-Fader visibility depends on these: only 'openai-realtime' +
    // captionAudioAvailable === true unlock the fader UI.
    captionEngine:             null,    // 'hybrid' | 'openai' | 'openai-realtime'
    captionAudioAvailable:     false,



    // Notifications / PWA
    notifyEnabled:          localStorage.getItem('notify-enabled') === '1',
    // Ruhemodus: nur diese Installation -- keine Anrufe, keine Meldungen
    quietMode:              localStorage.getItem('quiet-mode') === '1',
    deferredInstallPrompt:  null,
    activeJoinNotification: null,
    pushSubscription:       null,

    // UI-State
    activeTabId:      'tabChats',
    emojiPickerReady: false,
    tooltipEl:        null,
    tooltipTimeout:   null,

    // Chat — Identität
    chatMyPhone:     localStorage.getItem('chat-phone') || null,
    chatMyName:      localStorage.getItem('chat-name')  || '',
    chatMyPlan:        localStorage.getItem('chat-plan')  || 'free',
    // Plan-EIGENSCHAFTEN statt Plan-Namen (2026-08-30). Der Client verglich
    // vorher selbst gegen 'live'/'chat'/'live_plus' und haette bei jeder
    // Tarif-Umbenennung stumm falsch entschieden. Beide Werte kommen vom Server
    // in 'chat-authed' und 'plan-updated'.
    // Default false: bis die erste Server-Antwort da ist, wird nichts
    // freigeschaltet, was Geld kostet (fail-closed).
    chatPlanPaid:      localStorage.getItem('chat-plan-paid') === '1',
    chatPlanLiveQuota: localStorage.getItem('chat-plan-live-quota') === '1',
    // Kaufrecht Minutenpakete (2026-08-31): planPaid ODER Schalter
    // MINUTES_FREE_PURCHASE. Eigenes Feld, siehe chat-setup.js showMinutes.
    chatCanBuyMinutes: localStorage.getItem('chat-can-buy-minutes') === '1',
    // Anzeigename des Tarifs ("Premium"), kommt aus plan_config vom Server.
    // Der Client hatte dafuer eigene Namenslisten -- die kannten die neuen
    // Tarife nicht und zeigten dann den technischen Schluessel.
    chatPlanDisplayName: localStorage.getItem('chat-plan-name') || '',
    chatTrialEndsAt:   parseInt(localStorage.getItem('chat-trial-ends-at') || '0', 10),
    chatProTrialSecondsUsed:  parseInt(localStorage.getItem('chat-pro-trial-used') || '0', 10),
    chatProTrialSecondsTotal: parseInt(localStorage.getItem('chat-pro-trial-total') || '0', 10),
    // Live-Tier monthly cap (300 min total, 60 min thereof for groups with 3+ languages).
    // Server pushes 'live-cap-update' WS event with {used,total,groupUsed,groupTotal,periodStart}.
    chatLiveCapSecondsUsedMonth:    parseInt(localStorage.getItem('chat-live-cap-used') || '0', 10),
    chatLiveCapSecondsTotal:        parseInt(localStorage.getItem('chat-live-cap-total') || '0', 10),
    chatLiveCapGroupSecondsUsed:    parseInt(localStorage.getItem('chat-live-cap-group-used') || '0', 10),
    chatLiveCapGroupSecondsTotal:   parseInt(localStorage.getItem('chat-live-cap-group-total') || '0', 10),
    chatLiveCapPeriodStart:         parseInt(localStorage.getItem('chat-live-cap-period-start') || '0', 10),
    // Per-user flat rate (admin switch). Usage keeps counting, the monthly cap
    // simply doesn't apply — settings then show the usage without a bar.
    chatLiveCapUnlimited:           localStorage.getItem('chat-live-cap-unlimited') === '1',
    // Gekauftes Guthaben in Sekunden (Minutenkauf, 2026-08-30). Getrennt vom
    // Monatskontingent: es verfaellt nicht und ueberlebt den Monatswechsel.
    // Verbraucht wird erst das Kontingent, dann das Guthaben.
    chatLiveExtraSeconds:           parseInt(localStorage.getItem('chat-live-extra') || '0', 10),
    chatAuthToken:     localStorage.getItem('chat-auth-token') || null,
    chatAvatarHash:    localStorage.getItem('chat-avatar-hash') || null,
    chatRegistered:    !!localStorage.getItem('chat-phone'),

    // Chat — Daten
    chatChats:          [],
    chatMessages:       {},
    chatActiveChatId:   null,
    chatActiveIsGroup:  false,
    chatUnreadCounts:   {},

    // Gruppen
    chatGroups:          [],
    chatContactsSubTab:  'contacts',

    // Group Video Call
    groupCallActive:    false,
    groupCallId:        null,
    groupCallGroupId:   null,
    groupCallPeers:     new Map(),
    chatPresenceMap:    {},
    chatActivityMap:    {},
    chatScrollFabNewCount: 0,

    // Chat — Typing
    chatLastTypingSent:    0,
    chatTypingTimeout:     null,
    chatTypingHideTimeout: null,

    // Chat — Aufnahme
    chatRecording:          false,
    chatMediaRecorder:      null,
    chatRecordStart:        null,
    chatRecordMode:         localStorage.getItem('chat-record-mode') === 'video' ? 'video' : 'voice',
    chatRecordingTimerInterval:   null,
    chatRecordingLimitTimer:      null,
    chatRecordingIndicatorTimeout: null,
    chatRecordingSendInterval:    null,
    chatRecordArmTimer:           null,
    chatRecordHoldTimer:          null,
    chatRecordArmed:              false,
    chatRecordIgnoreClick:        false,

    // Chat — Audio-Player
    chatAudioPlayers:       {},
    chatCurrentlyPlaying:   null,

    // Chat — Reply / Edit
    chatReplyToId:         null,
    chatReplyToMsg:        null,
    chatEditingMessageId:  null,

    // Chat — Kontakte
    chatSavedContacts:    JSON.parse(localStorage.getItem('chat-contacts') || '[]'),
    chatMergedContacts:   [],
    chatPendingRequests:  [],
    chatSentRequests:     [],
    chatApprovedContacts: new Set(),
    chatContactsLoaded:   false,

    // Chat — E2E
    chatE2EEnabled: {},     // chatId → boolean
    chatE2EKeys:    {},     // peerPhone → AES CryptoKey (Cache)

    // Chat — Video-Processing
    chatVideoProcessingPollTimers: {},

    // Media-Preview (Drag & Drop / Datei-Auswahl)
    mediaPreviewFile:      null,
    mediaPreviewObjectUrl: null,
    mediaDragCounter:      0,

    // Interne Flags
    _accountKicked:  false,

    // SMS-Verifikation
    _smsTimerInterval: null,
    _smsPendingPhone:  null,
};

// ── Kompatibilitäts-Bridge (entfernt) ─────────────────────────
// Alle Module nutzen jetzt VCS.state.xxx direkt.
// Der Bridge-Code wurde in Phase 5 entfernt.
